var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('ProductManagement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }